import { Dialog, DialogContent, DialogProps, DialogTitle, Box } from '@mui/material';
import { CircularProgress, Typography } from '@occc-app/design-system';
import { TransactionFragment, useTransactionFraudulentInfoQuery } from '@occc/graphql';
import { TransactionFraudulentDetailsContent } from './TransactionFraudulentDetailsContent';

type TransactionFraudulentDetailsModalProps = {
  onClose?: DialogProps['onClose'];
  transaction: TransactionFragment;
};

export const TransactionFraudulentDetailsModal = ({
  transaction,
  onClose,
}: TransactionFraudulentDetailsModalProps) => {
  const { loading, data, error } = useTransactionFraudulentInfoQuery({
    variables: {
      transactionUuid: transaction.uuid,
    },
  });

  const renderContent = () => {
    if (error) {
      return (
        <Box p={4}>
          <Typography color='error'>Something went wrong. Please try again.</Typography>
        </Box>
      );
    }

    if (loading && !data) {
      return (
        <Box display='flex' justifyContent='center' alignItems='center' height={300}>
          <CircularProgress />
        </Box>
      );
    }

    if (!data || !data.transactionFraudulentInfo) {
      return (
        <Box p={4}>
          <Typography color='error'>No data. Please try again later.</Typography>
        </Box>
      );
    }

    return (
      <TransactionFraudulentDetailsContent
        fraudCheckResult={data.transactionFraudulentInfo}
        transaction={transaction}
      />
    );
  };

  return (
    <Dialog open onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>Fraud Details</DialogTitle>
      <DialogContent>{renderContent()}</DialogContent>
    </Dialog>
  );
};
